import React from 'react'
import theme from 'theme/index'
import {get} from 'lodash'
import ColorStatus from 'components/colorStatus'
import {getColorForQuoteStatus} from 'helpers/quotes'
import {getColorForJobCardStatus} from 'helpers/production'
import {getColorForDeliveryNoteStatusOptions} from 'helpers/deliveries/deliveryNotes'
import {getColorForInvoiceStatus} from 'helpers/invoices'
import {getActivityStatusColorForStatus} from 'helpers/activities'
import {getColorForPurchaseOrderStatus} from 'helpers/purchasing/purchaseOrders'
import {getColorForOpportunityStatus} from 'helpers/opportunities'
import {getDeliveryStatusColor} from 'helpers/deliveries/deliveries'
import {parseCssSelector, replaceAmpersandWithAnd} from 'helpers/css'

export const getApprovalOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const getColorOptionRender = (option, className) => {
  return (
    <div className={className}>
      <ColorStatus backgroundColor={option.colour}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const getJobStatusOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getColorForQuoteStatus(theme, option.value)}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const geJobBoardStatusOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getColorForJobCardStatus(theme, option.value)}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const getDeliveryNoteStatusOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getColorForDeliveryNoteStatusOptions(option.value)}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const getDeliveryStatusOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getDeliveryStatusColor(option.value)}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const getInvoiceStatusOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getColorForInvoiceStatus(theme, option.value)}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const getActivityStatusOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getActivityStatusColorForStatus(option.value)}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}

export const getPartSupplierCompanyOptionRender = (optionObject, partSupplierCompanyIds = []) => {
  const company = get(optionObject, 'company')
  const isExistingPartSupplier = partSupplierCompanyIds.includes(company.id)
  return (
    <div className={'option-container'}>
        <span className={'option-label'}>
          {company.name}
        </span>
      {isExistingPartSupplier
        ? (
          <div className={'part-supplier-dialog-allocation-error'}>
            You have already allocated this part supplier for this part pack
          </div>
        )
        : null
      }
    </div>
  )
}

export const getPurchaseOrderStatusOptionRender = (optionObject) => {
  const {option} = optionObject
  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getColorForPurchaseOrderStatus(option.status)}/>
      <span className={`option-label option-label-${replaceAmpersandWithAnd(parseCssSelector(option.label))}`}>
          {option.label}
        </span>
    </div>
  )
}

export const getOpportunityStatusOptionRender = (optionObject) => {
  const {option} = optionObject

  return (
    <div className={'option-container'}>
      <ColorStatus backgroundColor={getColorForOpportunityStatus(option.value)}/>
      <span className={'option-label'}>{option.label}</span>
    </div>
  )
}
